(ns dashboard.components.keybindings
  (:require
   [react]))

(defn keybindings
  "Installs a key listener around the given children, binding
  keystrokes to actions when no input field or textarea is in focus.


  Args:
  - `actions`: Map of key identifiers (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key)
    to functions to execute upon key press.
  - `children`: Sequence of child components to render.

  The function triggers an associated action from the ﻿actions map on
  keydown, and removes the event listener when the component is
  unmounted. Returns ﻿children as a React fragment."
  [{:keys [actions]} children]
  (react/useEffect (fn []
                     (let [listener (fn [e]
                                      (let [target (.-target e)
                                            action (get actions (.-key e))
                                            [action opts] (if (map? action)
                                                            [(:action action) (:opts action)]
                                                            [action nil])]
                                        (when (and action
                                                   (or (identical? target js/document.body)
                                                       (:allow-outside-body opts)))
                                          (.preventDefault e)
                                          (.stopImmediatePropagation e)
                                          (action))))]
                       (js/document.addEventListener "keydown" listener true)
                       (fn []
                         (js/document.removeEventListener "keydown" listener true))))
                   (array actions))
  [:<> children])
